import { render } from "./invoiceFileMock.vue?vue&type=template&id=a3f29c36"
import script from "./invoiceFileMock.vue?vue&type=script&lang=js"
export * from "./invoiceFileMock.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__